import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Providers from './components/Providers';
import { store } from '@data/store';
import { initAxios } from './api/axiosMiddleware';
import { injectBugsnagStore } from '@config/store';

injectBugsnagStore(store);
initAxios(store);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
